import { ProfileProgrammeAwardsCard } from './profile-programme-awards-card'
import { ProfileSeriesAwardsSkeleton } from './profile-series-awards-skeleton'
import React from 'react'
import { PageContainer } from 'src/component/page-container/page-container'
import { NoProfileSeriesAwards } from 'src/component/profile/no-profile-series-awards'
import { Grid } from 'src/component/ui/grid/grid'
import { useProgrammeAwards } from 'src/hook/use-challenges'

export const ProfileSeriesAwards = (): React.ReactElement => {
  const { data: seriesAwards, isLoading, isError } = useProgrammeAwards()
  const hasAwards = seriesAwards && seriesAwards.length > 0
  const isReady = !isLoading && !isError

  return (
    <PageContainer>
      <div className="pb-8 md:pb-[62px]">
        <h2 className="text-primary font-evogria text-2xl md:text-[44px] font-normal uppercase m-0 pt-8 md:pt-20 pb-5 md:pb-10">
          Series awards
        </h2>
        {isLoading || isError ? <ProfileSeriesAwardsSkeleton /> : null}
        {hasAwards && isReady ? (
          <Grid
            items={seriesAwards}
            keyExtractor={(programmeAward) => programmeAward.id}
            renderItem={(programmeAward) => <ProfileProgrammeAwardsCard programmeAward={programmeAward} />}
          />
        ) : null}
        {isReady && !hasAwards ? <NoProfileSeriesAwards /> : null}
      </div>
    </PageContainer>
  )
}
